var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-search-container"},[_c('a-input-search',{staticStyle:{"width":"225px"},attrs:{"placeholder":"请输入搜索内容"},on:{"search":function (value) { return _vm.$emit('onSearch', value); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }